import { ChargingStationDto } from "./chargingStationDto";
import { UserDto } from "./userDto";

export class ChargingstationGroupDto {
  id?: number;
  name: string;
  description?: string;
  countOfChargingStations?: number;
  chargingStations?: ChargingStationDto[];
  chargingStationsNames?: string;
  users?: UserDto[];
  chargingstationsEdited?: boolean;
  usersEdited?: boolean;
}
